import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { checkFileFormat, handleErrorMessage } from '../../utils';
import ButtonSave from '../Reusable/ButtonSave';
import withTranslations from '../../utils/HighOrderComponent';
import UploadFormTable from '../Reusable/UploadFormTable';
import {
  uploadFileMaxSize,
  requestForSignetstatusStatuses,
} from '../../constants/globals';
import ComboBoxAutocomplete from '../Reusable/ComboBoxAutocomplete';

class ModalForAddRequestForSignetStatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
      requestForSignetStatuses: [
        requestForSignetstatusStatuses.LOST,
        requestForSignetstatusStatuses.TERMINATED,
        requestForSignetstatusStatuses.COMPROMISED,
        requestForSignetstatusStatuses.NOT_CONSENTED,
      ],
      uploadedDocument: [],
      errors: {},
    };
  }

  handleClose = () => {
    this.props.handleClose();
  };

  onChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleDateChange = (date, value) => {};

  onFileChange = (e) => {
    this.setState({
      [e.target.name]: e.target.files,
    });
  };

  handleDeleteDocument = (documentName) => {
    let uploadedDocumentsNames = [];
    let uploadedDocumentsAsArray = Array.from(this.state.uploadedDocument);

    for (let i = 0; i < this.state.uploadedDocument.length; i++) {
      uploadedDocumentsNames.push(this.state.uploadedDocument[i].name);
    }

    var index = uploadedDocumentsNames.indexOf(documentName);
    uploadedDocumentsAsArray.splice(index, 1);
    this.setState({
      uploadedDocument: uploadedDocumentsAsArray,
    });
  };

  handleClientValidation = () => {
    let hasError = false;
    const { Errors } = this.props.t;
    let errors = {};

    if (this.state.status == null) {
      errors['status'] = Errors.status;
      hasError = true;
    }
    if (this.state.uploadedDocument.length === 0) {
      errors['uploadedDocument'] = Errors.uploadedDocument;
      hasError = true;
    }
    if (this.state.uploadedDocument.size >= uploadFileMaxSize) {
      errors['uploadedDocument'] = Errors.invalidFileSize;
      hasError = true;
    }
    if (this.state.uploadedDocument) {
      if (checkFileFormat(this.state.uploadedDocument)) {
        errors['uploadedDocument'] = Errors.invalidFormat;
        hasError = true;
      }
    }

    this.setState({ errors });

    return hasError;
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.handleClientValidation()) {
      return;
    }

    const newRequestForSignetstatus = {
      status: this.state.status,
      signet: this.props.signet,
    };

    let formData = new FormData();

    formData.append('file', this.state.uploadedDocument[0]);
    formData.append('name', this.state.uploadedDocument[0].name);
    formData.append(
      'requestForSignetStatus',
      new Blob([JSON.stringify(newRequestForSignetstatus)], {
        type: 'application/json',
      })
    );

    this.props.handleAdd(formData);
  };

  changeComboAutocompleteValue = (name, newValue) => {
    this.setState({ [name]: newValue.value });
  };

  render() {
    const { error, t } = this.props || {},
      { Placeholders, Labels } = t || {};

    return (
      <Modal
        show={this.props.show}
        onHide={this.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Body>
            {/* <ErrorHandler error={error} deleteError={deleteError} /> */}
            <h5 className="title text-center">{Labels.title}</h5>
            <form onSubmit={this.handleSubmit}>
              <div className="row">
                <div className="col-md-12 mt-3">
                  <ComboBoxAutocomplete
                    id="status"
                    data={this.state.requestForSignetStatuses}
                    text={(requestForSignetStatus) =>
                      requestForSignetStatus.text
                    }
                    changeValue={(newValue) =>
                      this.changeComboAutocompleteValue('status', newValue)
                    }
                    wholeObject
                    placeholder={Placeholders.statusSignet}
                    error={handleErrorMessage(
                      error,
                      'status',
                      this.state.errors.status
                    )}
                    updateValue={
                      this.state.status &&
                      this.state.requestForSignetStatuses.find(
                        (signetStatus) =>
                          signetStatus.value === this.state.status
                      )
                    }
                  />
                  {/* <label>
                    <em>
                      <span>* </span>
                      {Placeholders.statusSignet}
                    </em>
                  </label> */}
                  <UploadFormTable
                    name="uploadedDocument"
                    onChange={this.onFileChange}
                    handleDeleteDocument={this.handleDeleteDocument}
                    uploadedFiles={this.state.uploadedDocument}
                    placeholder={Placeholders.uploadedDocument}
                    errors={handleErrorMessage(
                      error,
                      'uploadedDocument',
                      this.state.errors.uploadedDocument
                    )}
                  />
                </div>
              </div>
              <div className="row">
                <ButtonSave onClick={this.handleSubmit} />
              </div>
            </form>
          </Modal.Body>
        </Modal.Header>
      </Modal>
    );
  }
}

export default withTranslations(
  ModalForAddRequestForSignetStatus,
  'ModalForAddRequestForSignetStatus'
);
